import * as c from '../constants/ReshipmentConstants'
import { isEmpty } from '../utils/common'

const initialState = {
  summary: {
    fetching: false,
    fetched: false,
    error: null,
    addingMaterial: false,
    data: {},
  },
  save: {
    saving: false,
    saved: false,
    error: null,
    name: null,
    lastUpdated: null,
    status: null,
    fetching: false,
    fetched: false,
    data: {},
  },
  submit: {
    submitting: false,
    submitted: false,
    error: null,
  },
  nonSecureMaterials: {
    fetching: false,
    fetched: false,
    error: null,
    data: {},
  },
  approvedReshipments: {
    fetching: false,
    fetched: false,
    error: null,
    data: [],
  },
}

export default (state = initialState, { type, payload }) => {
  function updateReshipQuantities(savedData, summaryData, nonSecureMaterials) {
    const updatedSummaryData = { ...summaryData }

    const testWindows = Object.keys(updatedSummaryData)
    // reset all items to 0
    testWindows.forEach(testWindow => {
      updatedSummaryData[testWindow].result.forEach(
        id => (updatedSummaryData[testWindow].entities.items[id].reshipQuantity = 0)
      )
    })
    const savedItemTestWindows = Object.keys(savedData)
    // update items with saved quantities
    savedItemTestWindows.forEach(testWindow => {
      savedData[testWindow].forEach(savedItem => {
        if (
          !isEmpty(updatedSummaryData[testWindow].entities.items) &&
          !isEmpty(updatedSummaryData[testWindow].entities.items[savedItem.ancillaryCd])
        ) {
          updatedSummaryData[testWindow].entities.items[savedItem.ancillaryCd] = {
            ...updatedSummaryData[testWindow].entities.items[savedItem.ancillaryCd],
            reshipQuantity: savedItem.quantity,
            isNonSecure: nonSecureMaterials[testWindow].some(
              item => item.ancillaryCd === savedItem.ancillaryCd
            ),
          }
        } else {
          // This is a non-secure item that won't be provided by summary data
          updatedSummaryData[testWindow].entities = {
            ...updatedSummaryData[testWindow].entities,
            items: {
              ...updatedSummaryData[testWindow].entities.items,
              [savedItem.ancillaryCd]: {
                ...savedItem,
                reshipQuantity: savedItem.quantity,
                isNonSecure: true,
              },
            },
          }
          // Also need to add item to result array
          updatedSummaryData[testWindow].result = [
            ...updatedSummaryData[testWindow].result,
            savedItem.ancillaryCd,
          ]
        }
      })
    })
    // Remove any non-secure items with a quantity of 0
    testWindows.forEach(testWindow => {
      updatedSummaryData[testWindow].result.forEach(ancillaryCd => {
        if (
          updatedSummaryData[testWindow].entities.items[ancillaryCd].isNonSecure &&
          updatedSummaryData[testWindow].entities.items[ancillaryCd].reshipQuantity === 0
        ) {
          delete updatedSummaryData[testWindow].entities.items[ancillaryCd]
          updatedSummaryData[testWindow].result = updatedSummaryData[testWindow].result.filter(
            resultId => resultId !== ancillaryCd
          )
        }
      })
    })
    return updatedSummaryData
  }

  switch (type) {
    case c.RESET_RESHIPMENT_FLOW:
      return initialState

    case c.FETCH_RESHIPMENT_SUMMARY_PENDING:
      return {
        ...state,
        summary: {
          ...state.summary,
          orgId: payload.orgId,
          educationPeriodCd: payload.educationPeriodCd,
          fetching: true,
          fetched: false,
          error: null,
        },
      }

    case c.FETCH_RESHIPMENT_SUMMARY_FULFILLED: {
      const { orgId, educationPeriodCd, reshipmentOrders } = payload
      return {
        ...state,
        summary: {
          ...state.summary,
          orgId,
          educationPeriodCd,
          data: reshipmentOrders,
          fetching: false,
          fetched: true,
          error: null,
        },
      }
    }

    case c.FETCH_RESHIPMENT_SUMMARY_REJECTED:
      return {
        ...state,
        summary: {
          ...state.summary,
          fetching: false,
          fetched: false,
          error: payload,
        },
      }

    case c.FETCH_SAVED_RESHIPMENT_ITEMS_PENDING:
      return {
        ...state,
        save: {
          ...state.save,
          fetching: true,
          fetched: false,
          error: null,
        },
      }

    case c.FETCH_SAVED_RESHIPMENT_ITEMS_FULFILLED: {
      const { name, lastUpdated, status, reshipmentOrders } = payload
      return {
        ...state,
        save: {
          ...state.save,
          name,
          lastUpdated,
          status,
          data: reshipmentOrders,
          fetching: false,
          fetched: true,
        },
        summary: {
          ...state.summary,
          data: updateReshipQuantities(
            reshipmentOrders,
            state.summary.data,
            state.nonSecureMaterials.data
          ),
        },
      }
    }

    case c.FETCH_SAVED_RESHIPMENT_ITEMS_REJECTED:
      return {
        ...state,
        save: {
          ...state.save,
          fetching: false,
          fetched: false,
          error: payload,
        },
      }

    case c.RESHIPMENT_SAVE_PENDING:
      return {
        ...state,
        save: {
          ...state.save,
          saving: true,
          saved: false,
          error: null,
        },
      }

    case c.RESHIPMENT_SAVE_FULFILLED: {
      const { name, lastUpdated, status, reshipmentOrders } = payload
      return {
        ...state,
        save: {
          ...state.save,
          name,
          lastUpdated,
          status,
          data: reshipmentOrders,
          saving: false,
          saved: true,
        },
        summary: {
          ...state.summary,
          data: updateReshipQuantities(
            reshipmentOrders,
            state.summary.data,
            state.nonSecureMaterials.data
          ),
        },
      }
    }

    case c.RESHIPMENT_SAVE_REJECTED:
      return {
        ...state,
        save: {
          ...state.save,
          saving: false,
          saved: false,
          error: payload,
        },
      }

    case c.RESHIPMENT_SUBMIT_PENDING:
      return {
        ...state,
        submit: {
          ...state.submit,
          submitting: true,
          submitted: false,
          error: null,
        },
      }

    case c.RESHIPMENT_SUBMIT_FULFILLED: {
      const { name, lastUpdated, status } = payload
      return {
        ...state,
        submit: {
          ...state.submit,
          submitting: false,
          submitted: true,
          error: null,
        },
        save: {
          ...state.save,
          name,
          lastUpdated,
          status,
        },
      }
    }

    case c.RESHIPMENT_SUBMIT_REJECTED:
      return {
        ...state,
        submit: {
          ...state.submit,
          submitting: false,
          submitted: false,
          error: payload,
        },
      }

    case c.ADD_NEW_MATERIAL: {
      const { examDateType: testWindow } = payload
      return {
        ...state,
        summary: {
          ...state.summary,
          addingMaterial: true,
          data: {
            ...state.summary.data,
            [testWindow]: {
              ...state.summary.data[testWindow],
              entities: {
                ...state.summary.data[testWindow].entities,
                items: {
                  ...state.summary.data[testWindow].entities.items,
                  [payload.ancillaryCd]: payload,
                },
              },
              result: [...state.summary.data[testWindow].result, payload.ancillaryCd],
            },
          },
        },
      }
    }

    case c.SELECT_NEW_MATERIAL: {
      const { examDateType: testWindow } = payload
      const modifiedItems = { ...state.summary.data[testWindow].entities.items }
      delete modifiedItems[c.NEW_ITEM]
      const modifiedResult = state.summary.data[testWindow].result.filter(id => id !== c.NEW_ITEM)
      return {
        ...state,
        summary: {
          ...state.summary,
          data: {
            ...state.summary.data,
            [testWindow]: {
              ...state.summary.data[testWindow],
              entities: {
                ...state.summary.data[testWindow].entities,
                items: {
                  ...modifiedItems,
                  [payload.ancillaryCd]: payload,
                },
              },
              result: [...modifiedResult, payload.ancillaryCd],
            },
          },
        },
      }
    }

    case c.CANCEL_ADD_NEW_MATERIAL: {
      const { testWindow, ancillaryCd } = payload
      const modifiedItems = { ...state.summary.data[testWindow].entities.items }
      delete modifiedItems[ancillaryCd]

      return {
        ...state,
        summary: {
          ...state.summary,
          addingMaterial: false,
          data: {
            ...state.summary.data,
            [testWindow]: {
              ...state.summary.data[testWindow],
              entities: {
                ...state.summary.data[testWindow].entities,
                items: modifiedItems,
              },
              result: [...state.summary.data[testWindow].result.filter(id => id !== ancillaryCd)],
            },
          },
        },
      }
    }

    case c.FINISHED_ADDING_NEW_MATERIAL:
      const { examDateType: testWindow } = payload
      return {
        ...state,
        summary: {
          ...state.summary,
          addingMaterial: false,
          data: {
            ...state.summary.data,
            [testWindow]: {
              ...state.summary.data[testWindow],
              entities: {
                ...state.summary.data[testWindow].entities,
                items: {
                  ...state.summary.data[testWindow].entities.items,
                  [payload.ancillaryCd]: {
                    ...state.summary.data[testWindow].entities.items[payload.ancillaryCd],
                    isNewItem: false,
                  },
                },
              },
            },
          },
        },
      }

    case c.FETCH_NON_SECURE_MATERIALS_PENDING:
      return {
        ...state,
        nonSecureMaterials: {
          ...state.nonSecureMaterials,
          fetching: true,
          fetched: false,
          error: null,
        },
      }

    case c.FETCH_NON_SECURE_MATERIALS_FULFILLED:
      return {
        ...state,
        nonSecureMaterials: {
          ...state.nonSecureMaterials,
          fetching: false,
          fetched: true,
          data: payload,
        },
      }

    case c.FETCH_NON_SECURE_MATERIALS_REJECTED:
      return {
        ...state,
        nonSecureMaterials: {
          ...state.nonSecureMaterials,
          fetching: false,
          fetched: false,
          error: payload,
        },
      }

    case c.RESHIPMENT_SUBMIT_PENDING:
      return {
        ...state,
        submit: {
          submitting: true,
          submitted: false,
          error: null,
        },
      }

    case c.RESHIPMENT_SUBMIT_FULFILLED:
      return {
        ...state,
        submit: {
          submitting: false,
          submitted: true,
        },
        summary: {
          ...state.summary,
          orgId: payload.orgId,
          educationPeriodCd: payload.educationPeriodCd,
          name: payload.name,
          lastUpdated: payload.lastUpdated,
          status: payload.status,
          data: payload.reshipmentOrders,
        },
      }

    case c.FETCH_APPROVED_RESHIPMENT_MATERIALS_PENDING:
      return {
        ...state,
        approvedReshipments: {
          ...state.approvedReshipments,
          fetching: true,
          fetched: false,
          error: null,
        },
      }

    case c.FETCH_APPROVED_RESHIPMENT_MATERIALS_FULFILLED:
      return {
        ...state,
        approvedReshipments: {
          ...state.approvedReshipments,
          fetching: false,
          fetched: true,
          data: payload,
        },
      }

    case c.FETCH_APPROVED_RESHIPMENT_MATERIALS_REJECTED:
      return {
        ...state,
        approvedReshipments: {
          ...state.approvedReshipments,
          fetching: false,
          fetched: false,
          error: payload,
        },
      }

    default:
      return state
  }
}
